<template>
  <el-row :gutter="18">
    <el-col :span="24" class="mb-3">
      <eb-enrollee-did-not-file-table :for-office="selectedOffice"></eb-enrollee-did-not-file-table>
    </el-col>
    <el-col :span="24" class="mb-3">
      <eb-enrollee-no-ack-table :for-office="selectedOffice"></eb-enrollee-no-ack-table>
    </el-col>
    <el-col :span="24" class="mb-3">
      <referral-validation-table :for-office="selectedOffice"></referral-validation-table>
    </el-col>
  </el-row>
</template>

<script>
import ReportBaseMixin from '@/views/reports/ReportBaseMixin';
import EbEnrolleeDidNotFileTable from '@/components/tables/EBEnrolleeDidNotFile.vue';
import EbEnrolleeNoAckTable from '@/components/tables/EBEnrolleeNoAck.vue';
import ReferralValidationTable from '@/components/tables/ReferralValidation.vue';

export default {
  components: {
    EbEnrolleeDidNotFileTable,
    EbEnrolleeNoAckTable,
    ReferralValidationTable,
  },
  mixins: [
    ReportBaseMixin,
  ],
};

</script>
